module.exports = __webpack_public_path__ + "img/visa.4e46d69a.svg";